export default __webpack_public_path__ + "static/media/mec-1.7181c110.png";